import clsx from 'clsx';
import { observer } from 'mobx-react';
import { useEffect, useMemo } from 'react';
import { Link } from 'react-router-dom';
import ParticipantsStore from '../../../ParticipantsStore';
import ParticipantsOptionsReactions from '../../../ParticipantsStore/Options/Reactions';
import ParticipantsReactions from '../../../ParticipantsStore/Reactions';
import { T } from '../../../Translations';
import Body from './Body';
import { currentUserStore } from '../../../CurrentUserStore';
import { findLink } from '../../../LinkyLinky';
import { emptyFragment } from '@execonline-inc/execonline-ui';

function Participants() {
  const participantsStore: ParticipantsStore = useMemo(() => new ParticipantsStore(), []);

  useEffect(() => participantsStore.loading(1), [participantsStore]);

  return (
    <>
      <div className="mt-7">
        <div className="mx-auto w-full max-w-clientPortalMaxWidth overflow-x-hidden">
          <div className="mb-2 flex flex-col justify-between px-2.5 md:flex-row lg:px-12">
            <div className="flex w-full items-center justify-between p-2">
              <h2 className="items-center text-2xl font-semibold text-foreground">
                <T kind="Participants" />
              </h2>
              <div>
                {findLink('import-multiple-participants', currentUserStore.links)
                  .orElse(() => findLink('import-participants', currentUserStore.links))
                  .map(() => (
                    <Link
                      to="/people/import_participants"
                      className={clsx(
                        'cursor-pointer rounded-md border border-solid font-semibold',
                        'border-primary bg-card px-3 py-2 text-sm text-primary',
                      )}
                      data-intercom-target="participants-import-button"
                    >
                      <T kind="Import participants" />
                    </Link>
                  ))
                  .getOrElse(emptyFragment)}
                {findLink('v2-create-participant', currentUserStore.links)
                  .map(() => (
                    <Link
                      to="/people/add_participant"
                      className={clsx(
                        'cursor-pointer rounded-md border border-solid font-semibold',
                        'border-primary bg-primary px-4 py-2 text-sm text-primary-foreground ml-2',
                      )}
                      data-intercom-target="participants-add-button"
                    >
                      <T kind="+ Add participant" />
                    </Link>
                  ))
                  .getOrElse(emptyFragment)}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="mx-auto max-w-clientPortalMaxWidth">
        <div className="px-2.5 lg:px-12">
          <Body participantsStore={participantsStore} />
        </div>
        <ParticipantsReactions store={participantsStore} fireImmediately />
        <ParticipantsOptionsReactions store={participantsStore.optionsStore} fireImmediately />
      </div>
    </>
  );
}

export default observer(Participants);
